<template>
  <v-container fill-height>
    <v-layout text-xs-center pt-5>
      <v-flex pt-5>
        <v-alert
          :value="true"
          color="warning"
          icon="fas fa-exclamation"
          outline
          class="mb-4"
        >
          <span class="headline font-weight-medium" data-test="NotFound">
            404 Error: Not Found
          </span>
        </v-alert>
        <div class="title">
          Oops, we couldn't find what you are looking for. Why don't you
          <router-link to="/" exact class="title" data-test="NotFoundLink">
            go home instead
          </router-link>
          ?
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'NotFound',
  metaInfo: {
    title: 'Not Found',
  },
};
</script>
